import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { View } from "../view";
import { Text } from "../text";
import { Icon } from "../icon";
import { ChevronRight } from '@az/starc-ui-icons';
import s from './Button.module.css';
export const ChevronButton = ({ startIcon, children }) => {
    return (_jsxs(View, { direction: "row", align: "center", gap: 3, width: "100%", justify: "space-between", wrap: false, children: [_jsx(View, { direction: "row", align: "center", gap: 3, children: _jsxs(_Fragment, { children: [startIcon || null, _jsx(View.Item, { children: children ? (_jsx(Text, { variant: "button", className: s.text, children: children })) : null })] }) }), _jsx(View, { gap: 3, className: s['--gap-auto'], children: _jsx(View, { className: s['--icon-chevron'], children: _jsx(Icon, { className: s['--icon-position-end'], svg: ChevronRight, size: 4.5 }) }) })] }));
};
